<template>
  <div class="Unusualhandle" v-loading="loading">
    <div class="account-card">
      <div class="account-card-header" style="margin-bottom:10px">
        <h4 class="account-card-title">处置异常处理</h4>
      </div>
      <el-button type="primary" @click="addNew" style="margin-bottom:10px"
        >新增</el-button
      >
      <customize-form
        :form-config="formConfig"
        @on-query="onQuery"
        @on-reset="onReset"
      ></customize-form>
      <customize-table
        :table-config="tableConfig"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :currentPage.sync="params.pageIndex"
      >
        <template v-slot:title="{ column }">
          <el-table-column v-bind="column">
            <template v-slot="scope">
              <span class="cell-link" @click="onCheck(scope.row)">{{
                scope.row.title
              }}</span>
            </template>
          </el-table-column>
        </template>
        <template v-slot:operTypeCode="{ column }">
          <el-table-column v-bind="column">
            <template v-slot="scope">
              {{
                scope.row.operTypeCode === '1'
                  ? '罚没保证金并公示'
                  : '不罚没不公示'
              }}
            </template>
          </el-table-column>
        </template>
        <template v-slot:reasonCode="{ column }">
          <el-table-column v-bind="column">
            <template v-slot="scope">
              {{ reasonArrs[scope.row.reasonCode] }}
            </template>
          </el-table-column>
        </template>
        <template v-slot:statusCode="{ column }">
          <el-table-column v-bind="column">
            <template v-slot="scope">
              {{
                scope.row.statusCode === '0' && scope.row.retrieveWhether === 1
                  ? '审批不通过'
                  : statusarr[scope.row.statusCode]
              }}
            </template>
          </el-table-column>
        </template>
        <template v-slot:operations="{ column }">
          <el-table-column v-bind="column" fixed="right">
            <template v-slot="scope">
              <el-button
                class="text-button"
                type="text"
                v-show="showUpdata(scope.row)"
                @click="changeFun(scope.row)"
                >修改</el-button
              >
              <el-button
                class="text-button"
                v-show="showUpdata(scope.row)"
                type="text"
                @click="delFun(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </template>
      </customize-table>
    </div>
  </div>
</template>
<script>
import { daterange, openNewPage } from '@/utils/constantime'

export default {
  name: 'UnusualHandle',
  data() {
    return {
      loading: false,
      removeV: 1,
      formConfig: {
        configs: {
          title: {
            tag: 'input',
            label: '异常标题'
          },
          buyerCompName: {
            tag: 'input',
            label: '买受人'
          },
          operTypeCode: {
            tag: 'select',
            label: '异常处理',
            default: null,
            options: [
              { value: 1, label: '罚没保证金并公示' },
              { value: 2, label: '不罚没不公示' }
            ]
          },
          reasonCode: {
            tag: 'select',
            label: '异常类型',
            default: null,
            options: [
              { value: 1, label: '买受人成交确认放弃' },
              { value: 2, label: '买受人成交后拒绝履行' },
              { value: 3, label: '处置企业原因无法执行' },
              { value: 4, label: '买受人未按要求完成物资交割（部分拉货）' },
              { value: 5, label: '其他通过非正当手段弄虚作假' }
            ]
          },
          noticeCode: {
            tag: 'input',
            label: '公告编号'
          },
          noticeTitle: {
            tag: 'input',
            label: '公告标题'
          },
          statusCode: {
            tag: 'select',
            label: '状态',
            default: null,
            options: [
              { value: null, label: '全部' },
              { value: '0', label: '未提交' },
              { value: '1', label: '已提交待审批' },
              { value: '2', label: '审批中' },
              { value: '3', label: '待运营确认' },
              { value: '01', label: '运营审批中' },
              { value: '4', label: '已发布' },
              { value: '5', label: '审批不通过' }
            ]
          },
          disposerCompName: {
            tag: 'input',
            label: '委托企业'
          },
          planCode: {
            tag: 'input',
            label: '委托编号'
          },
          submitTime: {
            ...daterange,
            label: '提交时间'
          }
        },
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      reasonArrs: {
        '1': '买受人成交确认放弃',
        '2': '买受人成交后拒绝履行',
        '3': '处置企业原因无法执行',
        '4': '买受人未按要求完成物资交割（部分拉货）',
        '5': '其他通过非正当手段弄虚作假'
      },
      statusarr: {
        '0': '未提交',
        '1': '已提交待审批',
        '2': '审批中',
        '3': '待运营确认',
        '01': '运营审批中',
        '02': '运营审批中',
        '4': '已发布'
      },
      tableConfig: {
        isPagination: true,
        columns: [
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center'
          },
          {
            slot: 'title',
            prop: 'title',
            label: '异常标题',
            'show-overflow-tooltip': true,
            width: '200px'
          },
          {
            prop: 'buyerCompName',
            label: '买受人',
            align: 'center',
            'show-overflow-tooltip': true,
            width: '200px'
          },
          {
            prop: 'reasonCode',
            slot: 'reasonCode',
            label: '异常类型',
            align: 'center',
            width: '200px',
            'show-overflow-tooltip': true
          },
          {
            prop: 'operTypeCode',
            slot: 'operTypeCode',
            label: '异常处理',
            align: 'center',
            'show-overflow-tooltip': true,
            width: '200px'
          },
          {
            prop: 'noticeCode',
            label: '公告编号',
            align: 'center',
            'show-overflow-tooltip': true,
            width: '180px'
          },
          {
            prop: 'noticeTitle',
            label: '公告标题',
            'show-overflow-tooltip': true,
            width: '180px'
          },
          {
            prop: 'planCode',
            label: '委托编号',
            'show-overflow-tooltip': true,
            width: '140px'
          },
          {
            prop: 'disposerCompName',
            label: '委托企业',
            'show-overflow-tooltip': true,
            width: '140px'
          },
          {
            prop: 'submitTime',
            label: '提交时间',
            align: 'center',
            width: '160px'
          },
          {
            prop: 'statusCode',
            slot: 'statusCode',
            label: '状态',
            align: 'center',
            width: '160px'
          },
          {
            slot: 'operations',
            prop: 'operations',
            label: '操作',
            width: '120px',
            align: 'center'
          }
        ],
        data: [],
        total: 0
      },
      params: {
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    addNew() {
      // openNewPage('newUnusual')
      this.$router.push({ name: 'ServiceExceptionDetail' })
    },
    async getList() {
      this.loading = true
      let data = await this.$api.serviceProvider.punishmentList({
        ...this.params
      })
      this.loading = false
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total || 0
    },
    onQuery(val) {
      if (val.submitTime) {
        val.submitTimeStart = val.submitTime[0]
        val.submitTimeEnd = val.submitTime[1]
        delete val.submitTime
      } else {
        delete val.submitTime
      }
      this.params = Object.assign(val, { pageSize: 10, pageIndex: 1 })
      this.getList()
    },
    onCurrentChange(val) {
      this.params.pageIndex = val
      this.getList()
    },
    onSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },
    remove(val) {
      this.removeV = val
    },
    onReset() {
      this.params = {
        pageIndex: 1,
        pageSize: 10
      }
      this.getList()
    },
    onCheckBidFile(o) {
      let query = {
        id: o.id,
        type: 'check'
      }
      openNewPage('ServiceExceptionCheck', query)
    },
    changeFun(o) {
      let query = {
        id: o.id
      }
      // openNewPage('newUnusual', query)
      this.$router.push({ name: 'ServiceExceptionDetail', query })
    },
    delFun(obj) {
      this.$confirm(`确认要删除 "${obj.title}" 公告吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.submitDel(obj.id)
        })
        .catch(() => {})
    },
    async submitDel(id) {
      let data = await this.$api.serviceProvider.deletePunishment({ id })
      if (data) {
        this.visible = false
        this.$message.success('删除成功')
        setTimeout(() => {
          this.params = {
            pageIndex: 1,
            pageSize: 10
          }
          this.getList()
        }, 2000)
      }
    },
    showUpdata(obj) {
      const { statusCode, retrieveWhether } = obj
      if (statusCode == 0 || (statusCode == 0 && retrieveWhether == 1)) {
        return true
      } else {
        return false
      }
    },
    onCheck(o) {
      this.$openNewPage('ServiceExceptionCheck', { id: o.id })
    }
  }
}
</script>
<style lang="less" scoped></style>
